export default "__VITE_ASSET__cde7cdfc__"